/* global messg */

import './styles.scss'

import React, { useState } from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'
import { getSharePayload } from 'lib/utils/courses/share'

import courseLogic from '../logic'

const SharingMenu = () => {
  const {
    course: { shareUrl, title },
    facebookApp
  } = useValues(courseLogic)

  const [isLinkModalOpen, setIsLinkModalOpen] = useState(null)

  const share = (event, type) => {
    event.preventDefault()
    window.open(...getSharePayload(type, shareUrl, title, facebookApp))
  }

  const copyLink = async event => {
    event.preventDefault()
    try {
      const response = await navigator.clipboard.writeText(window.location.href)
      if (response) {
        messg.success(I18n.t('courses.show.link_copied'), 1500)
      }
    } catch (error) {
      setIsLinkModalOpen(window.location.href)
    }
  }

  const emailLink = `mailto:?subject=${I18n.t('courses.show.mail_subject')}&body=${I18n.t(
    'courses.show.mail_body'
  )} ${shareUrl}`

  return (
    <div className='sharing-content'>
      <ul>
        <li>
          <h3>{I18n.t('courses.show_share.email_share_title')}</h3>
        </li>
        <li key='share-email'>
          <a href={emailLink} target='_blank' rel='noreferrer'>
            {I18n.t('activerecord.attributes.user.email')}
          </a>
        </li>
        {['messenger', 'whatsapp', 'facebook', 'twitter', 'linkedin'].map(socialMedia => (
          <li key={`share-${socialMedia}`} onClick={event => share(event, socialMedia)}>
            <a>{I18n.t(`courses.show.share_service.${socialMedia}`)}</a>
          </li>
        ))}
        <li key='share-copy-link' onClick={copyLink}>
          <a>{I18n.t('courses.show.copy_link')}</a>
        </li>
      </ul>
      {isLinkModalOpen && <input className='link-to-copy-input' onFocus={copyLink} value={isLinkModalOpen} />}
    </div>
  )
}

export default SharingMenu
